import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template base components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// nm2024 themed components
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
// images
import frPhotoPng from './images/hp-advisor.webp';
// styles
import {
  BulletedListStyled,
  ColStyled,
  LinkStyledButton,
  PictureStyled,
  SectionContainerStyled,
  TypographyStyledHeading,
} from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const mediumUp = theme.mediumUp();
  const [isMobile, setIsMobile] = useState(mediumUp);

  useEffect(() => {
    if (mediumUp !== isMobile) {
      setIsMobile(mediumUp);
    }
  }, [mediumUp, isMobile]);

  const getHeadingColumn = () => {
    return (
      <Col
        medium={8}
        align='center'>
        <TypographyStyledHeading
          component='h2'
          align='center'
          typeface='serif'
          disableBottomPadding>
          Your Northwestern Mutual advisor is here to <WidowBlock>guide you.</WidowBlock>
        </TypographyStyledHeading>
      </Col>
    );
  };

  return (
    <SectionContainerStyled
      id='home-page-fr-callout'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row align='center'>
        {mediumUp && getHeadingColumn()}
        <ColStyled medium={6}>
          <PictureStyled
            src={frPhotoPng}
            variant='round'
            altText='A Northwestern Mutual Financial Advisor' />
        </ColStyled>
        {!mediumUp && getHeadingColumn()}
        <Col medium={6}>
          <TypographyNm2024
            themeType='lightTheme'
            align='left'
            nextElement='typography'>
            They&#39;ll uncover opportunities that others might overlook&#8212;and build a personalized plan designed to drive better outcomes. You can expect:
          </TypographyNm2024>
          <BulletedListStyled
            bulletedListData={[
              { bulletText: 'The expertise to offer a range of financial solutions for every stage of your life' },
              { bulletText: 'To be heard, not judged, and your interests put above all else' },
              { bulletText: (<>Backing by a <strong><em>FORTUNE&#174;</em></strong> 125 company that&#39;s provided financial stability for 167 years</>) },
            ]}
            bulletType='checkmark' />
          <LinkStyledButton
            id='advisor-card-connect-button'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            ariaLabel='Get started with a Northwestern Mutual Financial Advisor'
            linkUrl='/find-a-financial-advisor/'>
            Let&#39;s get started
          </LinkStyledButton>
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
